import React, { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import "./About.css";

class About extends Component {
    render() {
        return (
            <div className="container-fluid m-0 p-0">
                {/* HERO SECTION */}
                <div className="recipe-hero text-center">
                    <h1 className="display-4 fw-bold pt-5">About Us🍽️</h1>
                    <p className="w-75 mx-auto text-light">
                        We craft recipes with passion,it's Your Cozy Home for Recipes,Every dish tells a story.
                    </p>
                </div>
                <div className="container py-5">

                    {/* ABOUT SECTION */}
                    <div className="row align-items-center mb-5">

                        <div className="col-lg-6 mb-4 div-center">
                            <img
                                src="./Asset/logo.png"
                                alt="About"
                                className="img-fluid rounded "
                                width={200} height={200}
                            />
                            
                        </div>

                        <div className="col-lg-6 right-column">
                            <h3 className="fw-bold mb-3">Our Story</h3>
                            <div className="orange-line mb-3"></div>

                            <p className="text-muted">
                            FlavoursNest is a place where food lovers can explore, cook, and enjoy a variety of delicious recipes. 
                            From quick everyday meals to authentic regional dishes, we bring together flavors that inspire your kitchen. 
                            Whether you're looking for cooking inspiration or trying to make the most of the ingredients you already have,
                            FlavoursNest makes discovering new recipes simple and enjoyable.
                            </p>

                            <p className="text-muted">
                                Our mission is to make cooking simple, enjoyable, and accessible
                                for everyone.
                            </p>

                            <ul className="list-unstyled mt-4">
                                <li className="mb-2">🍳 Easy-to-Cook Recipes</li>
                                <li className="mb-2">🍲 Easy Step-by-Step Instructions</li>
                                <li className="mb-2">✔ Tested & Trusted Recipes</li>
                                <li>💡 Creative & Modern Cooking</li>
                            </ul>
                        </div>
                    </div>

                    {/* WHY CHOOSE US */}
                    <div className="text-center mb-4">
                        <h3 className="fw-bold">Why Choose Us 🍲</h3>
                        <div className="orange-line mx-auto mb-4"></div>
                    </div>

                    <div className="row text-center">

                        <div className="col-md-4 mb-4">
                            <div className="card shadow-sm p-4 h-100">
                                <h5 className="fw-bold">Authentic Taste</h5>
                                <p className="text-muted">
                                    Traditional flavors blended with modern techniques.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="card shadow-sm p-4 h-100">
                                <h5 className="fw-bold">Healthy Options</h5>
                                <p className="text-muted">
                                    Balanced meals crafted with nutrition in mind.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4 mb-4">
                            <div className="card shadow-sm p-4 h-100">
                                <h5 className="fw-bold">Creative Recipes</h5>
                                <p className="text-muted">
                                    Unique dishes that inspire your everyday cooking.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(About);